import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, XCircle } from 'lucide-react';
export function ProblemSection() {
  const frustrations = ['No sabes por dónde empezar', 'La tecnología te abruma', 'El tiempo nunca te alcanza', 'La inestabilidad económica sigue ahí'];
  const failures = ['Empezaste sin un plan claro', 'Probaste modelos complicados o costosos', 'La tecnología te abrumó', 'Quisiste hacer demasiado a la vez'];
  return <section className="py-24 px-6 lg:px-8 bg-brand-light text-slate-900" data-id="element-150">
      <div className="max-w-5xl mx-auto" data-id="element-151">
        {/* Frustrations Block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-152">
          <h2 className="font-heading text-3xl md:text-4xl font-bold mb-6 text-brand-dark" data-id="element-153">
            Lanza tu primer micro-negocio en 7 días —{' '}
            <span className="text-brand-accent" data-id="element-154">
              aunque no tengas idea por dónde empezar
            </span>
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto mb-10" data-id="element-155">
            Has intentado ganar dinero extra, pero siempre te topas con la misma
            pared. Postergas tu proyecto una vez más porque:
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-3xl mx-auto text-left" data-id="element-156">
            {frustrations.map((item, index) => <div key={index} className="flex items-center gap-3 p-4 bg-white rounded-xl shadow-sm border border-slate-100" data-id="element-157">
                <AlertCircle className="w-5 h-5 text-brand-secondary shrink-0" data-id="element-158" />
                <span className="font-medium text-slate-700" data-id="element-159">{item}</span>
              </div>)}
          </div>
        </motion.div>

        {/* Why it failed Block */}
        <div className="mt-20" data-id="element-160">
          <motion.h3 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-heading text-2xl md:text-3xl font-bold mb-10 text-center text-brand-dark" data-id="element-161">
            ¿Por qué no te ha funcionado antes?
          </motion.h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-162">
            {failures.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-4 p-6 bg-white rounded-2xl shadow-sm border border-slate-200 hover:border-red-200 hover:shadow-md transition-all" data-id="element-163">
                <div className="p-2 bg-red-50 rounded-lg shrink-0" data-id="element-164">
                  <XCircle className="w-6 h-6 text-red-500" data-id="element-165" />
                </div>
                <p className="text-slate-700 font-medium text-lg pt-1" data-id="element-166">
                  {item}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}